
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.334.833H6.667C3.444.833.863 3.443.863 6.667l-.029 52.5L12.501 47.5h40.833a5.832 5.832 0 005.833-5.833v-35A5.832 5.832 0 0053.334.833zM12.501 21.25h35v5.833h-35V21.25zm23.333 14.583H12.501V30h23.333v5.833zm11.667-17.5h-35V12.5h35v5.833z","fill":"#324997"}})])
          )
        }
      }
    